import React from "react";
import _ from "lodash";
import MultiPicker from "../../forms/MultiPicker";
import { useGridData } from "../GridDataContext";

/**
 * Edit picker cell component
 * @module
 * @param {func} parentProps - Parent props contains data
 * @param {func} itemChange - Item Change function
 * @param {func} getColumns - Get columns function
 */
export const editMultiPickerCell = ({ getColumns, withMeta, isValueChanged  }) => {
  const MultiPickerCell = (props) => {
    const { dataItem, onChange: onChangeItem, field, tdProps, isInEdit } = props;

    const handleChange = (name, selected) => {
      onChangeItem({
        dataItem: dataItem,
        field: name,
        syntheticEvent: new Event("change"),
        value: selected,
      });
    };

    const getValue = (dataValue, column) => {
      return _.isArray(dataValue) ? dataValue.map(x => x[column.textField]).join(", ") : "";
    };


    const dataValue = dataItem[field] === null ? "" : dataItem[field];
    const x = getColumns().find((item) => item.field === field);
    const selected = dataItem[field];

    const data = useGridData(`${x?.identif}`);
    const onChange = useGridData(`${x?.onChange}`);
    const onSubmit = useGridData(`${x?.onSubmit}`);

    return <td
      {...tdProps}
      className={`${tdProps.className} ${isValueChanged && isValueChanged(dataItem, field) ? "k-state-changed" : ""}`}
      tabIndex={0}
    >
      {isInEdit ? (
        <MultiPicker
          textField={x.textField}
          valueField={x.valueField || x.textField}
          onChange={onChange}
          onSubmit={onSubmit}
          data={data ? data.data : []}
          isLoading={data ? data.isLoading : false}
          onSelect={handleChange}
          selected={selected}
          schema={x.schema}
          total={data ? data.total : 0}
          disabled={x.disabled}
          name={x.field}
          primaryField={x.primaryField}
          identif={x.identif}
          title={x.title}
          fixedFilter={x.fixedFilter}
          required={x.required}
          /*isOpen={state.isOpenPicker}*/
          // openPicker={handleOpenPicker}
          // closePicker={handleClosePicker}
          placeholder={"Zvoľte hodnotu"}
          currentDataItem={dataItem}
          // parentProps={parentProps}
          withMeta={withMeta}
          onBlur={() => { }}
        />
      ) : (
        x ? getValue(dataValue, x) : null
      )}
    </td>
  }
  return MultiPickerCell;
}
